import React from 'react';
import Icon from '../../../components/AppIcon';

const DignitiesSection = ({ data, isVisible, onToggle }) => {
  if (!data || data?.length === 0) return null;

  const getDignityBadge = (dignityEn) => {
    const dignityConfig = {
      'Exaltation': { bg: 'bg-success/10', text: 'text-success', icon: 'TrendingUp' },
      'Domicile': { bg: 'bg-primary/10', text: 'text-primary', icon: 'Home' },
      'Detriment': { bg: 'bg-warning/10', text: 'text-warning', icon: 'TrendingDown' },
      'Fall': { bg: 'bg-error/10', text: 'text-error', icon: 'ArrowDown' }
    };

    const config = dignityConfig?.[dignityEn] || { bg: 'bg-muted', text: 'text-muted-foreground', icon: 'Minus' };
    return config;
  };

  return (
    <section id="dignities" className="scroll-mt-20">
      <div className="bg-card border border-border rounded-lg shadow-brand-md overflow-hidden">
        <button
          onClick={onToggle}
          className="w-full flex items-center justify-between px-4 md:px-6 py-4 hover:bg-muted transition-smooth"
          aria-expanded={isVisible}
        >
          <div className="flex items-center">
            <div className="w-10 h-10 bg-error/10 rounded-lg flex items-center justify-center mr-3">
              <Icon name="Award" size={20} color="var(--color-error)" />
            </div>
            <div className="text-left">
              <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
                ศักดิ์ศรีดาว
              </h2>
              <p className="text-xs md:text-sm text-muted-foreground">Dignities</p>
            </div>
          </div>
          <Icon 
            name={isVisible ? "ChevronUp" : "ChevronDown"} 
            size={24} 
            color="var(--color-muted-foreground)"
          />
        </button>

        {isVisible && (
          <div className="border-t border-border">
            {/* Desktop Table View */}
            <div className="hidden lg:block overflow-x-auto">
              <table className="w-full">
                <thead className="bg-muted">
                  <tr>
                    <th className="px-6 py-3 text-left text-sm font-caption font-medium text-foreground uppercase tracking-wide">
                      ดาวเคราะห์
                      <span className="block text-xs text-muted-foreground normal-case">Planet</span>
                    </th>
                    <th className="px-6 py-3 text-left text-sm font-caption font-medium text-foreground uppercase tracking-wide">
                      สถานะศักดิ์ศรี
                      <span className="block text-xs text-muted-foreground normal-case">Dignity Status</span>
                    </th>
                    <th className="px-6 py-3 text-left text-sm font-caption font-medium text-foreground uppercase tracking-wide">
                      การปกครองบ้าน
                      <span className="block text-xs text-muted-foreground normal-case">House Rulership</span>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-border">
                  {data?.map((dignity, index) => {
                    const badge = getDignityBadge(dignity?.dignityStatusEn);
                    return (
                      <tr key={index} className="hover:bg-muted/50 transition-smooth">
                        <td className="px-6 py-4 text-sm font-medium text-foreground">
                          {dignity?.planetTh}
                          <span className="block text-xs text-muted-foreground">{dignity?.planetEn}</span>
                        </td>
                        <td className="px-6 py-4">
                          <div className="flex items-center">
                            <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${badge?.bg} ${badge?.text}`}>
                              <Icon name={badge?.icon} size={14} className="mr-1.5" />
                              {dignity?.dignityStatusTh}
                            </span>
                            <span className="ml-2 text-xs text-muted-foreground">{dignity?.dignityStatusEn}</span>
                          </div>
                        </td>
                        <td className="px-6 py-4 text-sm text-foreground">
                          {dignity?.houseRulershipTh}
                          <span className="block text-xs text-muted-foreground">{dignity?.houseRulershipEn}</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Mobile Card View */}
            <div className="lg:hidden divide-y divide-border">
              {data?.map((dignity, index) => {
                const badge = getDignityBadge(dignity?.dignityStatusEn);
                return (
                  <div key={index} className="p-4 hover:bg-muted/50 transition-smooth">
                    <div className="flex items-start justify-between mb-3">
                      <div>
                        <h3 className="text-base font-medium text-foreground">{dignity?.planetTh}</h3>
                        <p className="text-sm text-muted-foreground">{dignity?.planetEn}</p>
                      </div>
                      <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${badge?.bg} ${badge?.text}`}>
                        <Icon name={badge?.icon} size={14} className="mr-1" />
                        {dignity?.dignityStatusTh}
                      </span>
                    </div>
                    <div className="space-y-2">
                      <div>
                        <p className="text-xs text-muted-foreground mb-1">สถานะศักดิ์ศรี (Dignity Status)</p>
                        <p className="text-sm text-foreground">{dignity?.dignityStatusEn}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground mb-1">การปกครองบ้าน (House Rulership)</p>
                        <p className="text-sm text-foreground">{dignity?.houseRulershipTh}</p>
                        <p className="text-xs text-muted-foreground">{dignity?.houseRulershipEn}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default DignitiesSection;